import { render, staticRenderFns } from "./GithubRibbon.vue?vue&type=template&id=6895b09c&"
import script from "./GithubRibbon.vue?vue&type=script&lang=ts&"
export * from "./GithubRibbon.vue?vue&type=script&lang=ts&"
import style0 from "./GithubRibbon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports